<template>
  <div class="notifiEventTypeRowContainer">
    <div class="notifi-configs-container">
      <label>{{ props.config.name }}</label>
      <span
        v-if="props.config.tooltipContent"
        v-tooltip="props.config.tooltipContent"
        class="pi pi-info-circle notifi-info-tooltip"
      />
    </div>
    <NotifiToggle
      :disabled="loading"
      :checked="isChecked"
      :set-checked="handleInstantSubscription"
    />
  </div>
</template>
<script lang="ts" setup>
import {
  BroadcastEventTypeItem,
  DirectPushEventTypeItem,
  PriceChangeEventTypeItem,
} from '@notifi-network/notifi-frontend-client';
import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue';
import { NotifiToggle } from '.';
import { useNotifiStore } from '../../stores';

type EventTypeDirectPushRowProps = {
  disabled?: boolean;
  config:
    | DirectPushEventTypeItem
    | BroadcastEventTypeItem
    | PriceChangeEventTypeItem;
  inputs: Record<string, string | undefined>;
};

const props = defineProps<EventTypeDirectPushRowProps>();
const GENERAL_ERROR_MESSAGE = 'Something went wrong. Please try again';
const isLoading = ref<boolean>(false);

const notifiStore = useNotifiStore();

const { clientData, loading } = storeToRefs(notifiStore);

const { setErrorMessage } = notifiStore;
const isChecked = ref<boolean>(
  clientData.value.alerts.find((it) => it?.name === props.config.name) !==
    undefined,
);
const setIsChecked = (value: boolean) => {
  isChecked.value = value;
};
const setIsLoading = (value: boolean) => {
  isLoading.value = value;
};

const handleInstantSubscription = () => {
  setIsLoading(true);
  setErrorMessage('');
  if (isChecked.value === false) {
    setIsChecked(true);

    notifiStore
      .subscribe(props.config, props.inputs)
      .catch(() => {
        setErrorMessage(GENERAL_ERROR_MESSAGE);
        setIsChecked(false);
      })
      .finally(() => {
        GENERAL_ERROR_MESSAGE;
        setIsLoading(false);
      });
  } else {
    setIsChecked(false);
    notifiStore
      .unsubscribe(props.config.name)
      .catch(() => {
        setErrorMessage(GENERAL_ERROR_MESSAGE);
        setIsChecked(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }
};

watch(
  () => clientData.value,
  (newClientData) => {
    isChecked.value =
      newClientData.alerts.find((it) => it?.name === props.config.name) !==
      undefined;
  },
);
</script>

<style lang="scss">
.notifiEventTypeRowContainer {
  display: flex;
  justify-content: space-between;
}

.notifi-info-tooltip {
  margin-left: 8px;
  color: #979797;
}

.notifi-configs-container {
  display: flex;
  align-items: center;
}
</style>
